// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import entityDictionaryEntity from './entities/entity-dictionary.json';
import entityDictionaryMenu from '../pages/entity-dictionary/menu.json';
import entityDictionaryFullForm from '../pages/entity-dictionary/forms/full.json';
import entityDictionaryContextForm from '../pages/entity-dictionary/forms/context.json';
import entityDictionaryMiniForm from '../pages/entity-dictionary/forms/mini.json';
import entityDictionaryLookupForm from '../pages/entity-dictionary/forms/lookup.json';
import entityDictionaryTableView from '../pages/entity-dictionary/views/table.json';
import entityDictionaryCardsView from '../pages/entity-dictionary/views/cards.json';
import entityDictionaryDashboardView from '../pages/entity-dictionary/views/dashboard.json';

/** Тип запису «Довідник» зі сторінками пакета: меню, форми та подання з pages/entity-dictionary/. */
export const entityDictionaryDefinition: IRecordTypeDefinition = {
  ...entityDictionaryEntity,
  views: assembleViewSet({
      table: entityDictionaryTableView,
      cards: entityDictionaryCardsView,
      dashboard: entityDictionaryDashboardView,
  }),
  form: entityDictionaryFullForm,
  forms: { full: entityDictionaryFullForm, context: entityDictionaryContextForm, mini: entityDictionaryMiniForm, lookup: entityDictionaryLookupForm },
  menu: entityDictionaryMenu,
} as IRecordTypeDefinition;
